export const isProviderServiceSelected = (service, selectedService) => {
  if (selectedService?.serviceCollectionGuid) {
    return service.serviceCollectionGuid === selectedService.serviceCollectionGuid;
  }

  if (selectedService?.serviceId) {
    return service.serviceId === selectedService.serviceId && service.sellerLabelProviderId === selectedService.sellerLabelProviderId;
  }

  return false;
};

const createItemForProviderService = (service, selectedService) => {
  return {
    ...service,
    selected: isProviderServiceSelected(service, selectedService),
  };
};

export const mapItemsForProviderServices = (services, selectedService) => {
  return services.map((service) => createItemForProviderService(service, selectedService));
};

export const updateProviderServicesWithSelectedProperty = (services, selectedService) => {
  return services.map((service) => ({
    ...service,
    items: mapItemsForProviderServices(service.items, selectedService),
  }));
};
